import * as React from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import {
  IRouterConditionProps,
  IRouterConditionState,
  RouterCondition
} from 'routes/interfaces'

export const withCondition = (
  condition: RouterCondition,
  onRedirect?: () => void
) => (Component?: React.ElementType) => {
  class WithCondition extends React.Component<
    IRouterConditionProps,
    IRouterConditionState
  > {
    check = (prevProps?: IRouterConditionProps) => {
      const { history, auth_user } = this.props
      const altRoute = condition(this.props, prevProps)

      if (auth_user.authUser !== undefined && altRoute) {
        if (onRedirect) {
          onRedirect()
        }

        history.replace(altRoute)
      }
    }

    componentDidMount() {
      this.check()
    }

    componentDidUpdate(prevProps: IRouterConditionProps) {
      this.check(prevProps)
    }

    render() {
      const altRoute = condition(this.props)
      return this.props.auth_user.authUser !== undefined && Component ? (
        <Component {...this.props} altRoute={altRoute} />
      ) : (
        <></>
      )
    }
  }

  const withHOCs = compose(withRouter)(WithCondition)

  const mapStateToProps = state => state
  const mapDispatchToProps = dispatch => ({})

  const Connected = connect(mapStateToProps, mapDispatchToProps)(withHOCs)

  return (props: IRouterConditionProps) => <Connected {...props} />
}



// WEBPACK FOOTER //
// ./src/components/Session/withCondition.tsx